
export function initSlider() {

    if ( document.querySelector('.tips-block .tips-list, .products-slider, .custom-wpac .grw-reviews')) {

        Promise.all([
            import('swiper'),
            import('swiper/modules'),
        ]).then(([Swiper, SwiperModules]) => {
            const { Navigation } = SwiperModules;

            document.querySelectorAll('.tips-block .tips-list').forEach((slider) => {
                new Swiper.default(slider, {
                    modules: [Navigation],
                    loop: false,
                    spaceBetween: 20,
                    slidesPerView: 2,
                    navigation: {
                        nextEl: '.tips-button-next',
                        prevEl: '.tips-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                        },
                        976: {
                            slidesPerView: 3,
                        },
                        1024: {
                            slidesPerView: 5,
                        },
                    }
                })
            });

            document.querySelectorAll('.products-slider').forEach((slider) => {
                let productSwiper = '';
                const productSliderConfig = {
                    loop: true,
                    lazy: true,
                    spaceBetween: 0,
                    slidesPerView: 'auto',
                    slideClass: 'product',
                    initBreakpoint: 900,
                }

                if (window.innerWidth <= productSliderConfig['initBreakpoint']) {
                    productSwiper = new Swiper.default(slider, productSliderConfig);
                }

                window.addEventListener('resize', () => {
                    if (window.innerWidth <= productSliderConfig['initBreakpoint']) {
                        if (!productSwiper) {
                            productSwiper = new Swiper.default(slider, productSliderConfig);
                        }
                    } else if (productSwiper) {
                        productSwiper.destroy();
                        productSwiper = null;
                    }
                });
            });

            document.querySelectorAll('.custom-wpac .grw-reviews').forEach((slider) => {
                new Swiper.default(slider, {
                    loop: true,
                    lazy: true,
                    spaceBetween: '20px',
                    slidesPerView: 'auto',
                    slideClass: 'grw-review',
                });
            });
        });
    }
}